import React from 'react';
import PropTypes from 'prop-types';

import styles from './DisplayButton.scss';

const DisplayButton = ({
  src,
  text,
  selected,
  top
}) => (
  <div
    className={
      `${styles.DisplayButton}
      ${selected ? styles.selected : ''}
      ${top ? styles.top : ''}`
    }
  >
    {src && <i className={styles[src]} />}
    {text}
  </div>
);

DisplayButton.defaultProps = {
  src: '',
  text: '',
  selected: false,
  top: false
};

DisplayButton.propTypes = {
  src: PropTypes.string,
  text: PropTypes.string,
  selected: PropTypes.bool,
  top: PropTypes.bool
};

export default DisplayButton;




// WEBPACK FOOTER //
// ./src/components/buttons/DisplayButton/DisplayButton.js